import { createFileRoute } from '@tanstack/react-router';

import { getSupportTicketsQueryOptions, SupportListLoading } from '@/_containers/support';
import { getContactQueryOptions } from '@/_pages/contacts/api-service';

export const Route = createFileRoute('/_private/contacts/_template/$id/support/')({
  loader: async (opts) => {
    const contactData = await opts.context.queryClient.ensureQueryData(getContactQueryOptions(opts.params.id));
    opts.context.queryClient.ensureQueryData(
      getSupportTicketsQueryOptions({ contactId: contactData.data.freshdesk?.toString() || '' })
    );
  },
  staticData: {
    pageTitle: 'Support Tickets',
    tabKey: 'contacts/support',
    isFullWidth: true,
    isViewOnly: true,
  },
  pendingComponent: SupportListLoading,
});
